var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.12 93.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.51,77.57V3.85c0-1.12-.37-1.99-1.12-2.73s-1.61-1.12-2.73-1.12H3.85C2.73,0,1.86,.37,1.12,1.12S0,2.73,0,3.85V85.27c0,2.11,.74,3.97,2.36,5.46,1.49,1.61,3.35,2.36,5.46,2.36H120.27c1.12,0,1.99-.37,2.73-1.12s1.12-1.61,1.12-2.73v-7.82c0-1.12-.37-1.99-1.12-2.73s-1.61-1.12-2.73-1.12H15.51ZM83.9,7.7c-2.61,0-4.34,1.24-5.34,3.72-.99,2.36-.62,4.47,1.24,6.33l7.7,7.7-17.63,18-17.75-18c-1.61-1.49-3.48-2.23-5.59-2.23s-3.97,.74-5.59,2.23l-16.51,16.76c-1.86,1.74-1.86,3.6,0,5.59l5.34,5.34c1.99,1.86,3.85,1.86,5.59,0l11.17-11.17,17.75,17.87c1.61,1.49,3.48,2.23,5.59,2.23,1.99,0,3.85-.74,5.46-2.23l23.33-23.21,7.7,7.7c1.86,1.86,3.97,2.23,6.33,1.24,2.48-.99,3.72-2.73,3.72-5.34V11.67c0-1.12-.37-2.11-1.12-2.85-.74-.74-1.74-1.12-2.85-1.12h-28.55Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.320c20498b9b34437e5146f178203351.svg";
export { ForwardRef as ReactComponent };